import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Text, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_KIND,
} from '@/bit/components/components.text';
import { sendTaggingInfo } from './utils';

function RadioButton({
  className,
  id,
  name,
  label,
  options,
  error,
  onChange,
  value,
  disabled,
  sendTagging
}) {
  const [selectedValue, setSelectedValue] = useState(value);
  const taggingInfo = {
    componentVariation: 'all',
    componentContent: label,
    componentProduct: '',
    componentName: 'radio',
  };


  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleOnChange = (element) => {
    if(sendTagging){
      sendTaggingInfo({...taggingInfo, componentContent: `check-${element.target.value}`}, 'change');
    }
    onChange(element);
  };

  return (
    <div className={`radio-group-wrapper ${className}`} data-cy={id}>
      {label && (
        <div className="radio-group-wrapper_label">
          <Text
            className="radio-group-wrapper_label"
            text={label}
            kind={TEXT_KIND.SPAN}
            size={TEXT_SIZE.CAPTION3}
            cyData={`${id}__label`}
          />
        </div>
      )}
      <div className="radio-group-wrapper_options">
        {options.map((option) => (
          <label
            key={option.value}
            htmlFor={`${name}-${option.value}`}
            data-cy={`${id}__option-${option.value}`}
          >
            <input
              className={`${error ? 'error' : ''} ${selectedValue === option.value ? 'selected' : ''}`}
              id={`${name}-${option.value}`}
              name={name}
              type="radio"
              value={option.value}
              selected={selectedValue == option.value}
              onChange={handleOnChange}
              data-cy={`${id}__input-${option.value}`}
              disabled={disabled}
            />
            {option.label && <div className="labelText">{option.label}</div>}
          </label>
        ))}
      </div>
      {error && (
        <Text
          className="radio-group-wrapper_error"
          text={error}
          color={TEXT_COLOR.RED}
          kind={TEXT_KIND.SPAN}
          size={TEXT_SIZE.CAPTION3}
          cyData={`${id}__error`}
        />
      )}
      <style jsx>{`@import "styles/colors.scss";
      
.radio-group-wrapper {
  margin: 1rem 0;
}

.radio-group-wrapper_label {
  display: block;
  margin-bottom: 1rem;
}

.radio-group-wrapper_options label {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.radio-group-wrapper_options input[type='radio'] {
  -webkit-appearance: none;
  appearance: none;
  min-width: 1.5rem;
  min-height: 1.5rem;
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.625rem;
  border: 0.0625rem solid $color--grey_400;
  border-radius: 50%;
  outline: none;
  cursor: pointer;
  background-color: $color--white;
  position: relative;
}

.radio-group-wrapper_options input[type='radio']:focus {
  border: 0.0625rem solid $color--movistar_blue;
}

.radio-group-wrapper_options input[type='radio'].selected {
  background-color: $color--white !important;
  border: 0.125rem solid $color--movistar_blue !important;
  position: relative;
}

.radio-group-wrapper_options input[type='radio'].error {
  border: 0.0625rem solid $color-gp--red !important;
}

.radio-group-wrapper_options input[type='radio'].selected::before {
  content: '';
  display: block;
  width: 0.625rem;
  height: 0.625rem;
  background-color: $color--movistar_blue;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.radio-group-wrapper_options .labelText {
  display: inline;
}

:global(.radio-group-wrapper_error) {
  padding: 0.125rem 0 0 0;
}`}</style>
    </div>
  );
}

RadioButton.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

RadioButton.defaultProps = {
  className: '',
  label: '',
  value: '',
  error: '',
  onChange: () => {},
  disabled: false,
};

export default RadioButton;